import { StateCreator } from 'zustand';

import { BrainFavoritesSlice, BrainStore, INITIAL_BRAIN_STATE } from '../types';

export const createFavoritesSlice: StateCreator<
  BrainStore,
  [],
  [],
  BrainFavoritesSlice
> = (set) => ({
  favoritePageIds: INITIAL_BRAIN_STATE.favoritePageIds,
  favoritePages: INITIAL_BRAIN_STATE.favoritePages,
  isLoadingFavorites: INITIAL_BRAIN_STATE.isLoadingFavorites,

  setFavorites: (pages) => {
    set({
      favoritePages: pages,
      favoritePageIds: pages.map((p) => p.pageId),
    });
  },

  addFavorite: (pageId, page) => {
    set((state) => {
      const hasId = state.favoritePageIds.includes(pageId);
      const hasMeta =
        !page || state.favoritePages.some((p) => p.pageId === pageId);
      if (hasId && hasMeta) {
        return {};
      }
      return {
        favoritePageIds: hasId
          ? state.favoritePageIds
          : [pageId, ...state.favoritePageIds],
        favoritePages: hasMeta
          ? state.favoritePages
          : [page, ...state.favoritePages],
      };
    });
  },

  removeFavorite: (pageId) => {
    set((state) => ({
      favoritePageIds: state.favoritePageIds.filter((id) => id !== pageId),
      favoritePages: state.favoritePages.filter((p) => p.pageId !== pageId),
    }));
  },

  setLoadingFavorites: (loading) => {
    set({ isLoadingFavorites: loading });
  },
});
